import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserToken } from './context/UserTokenContext';

const PrivateRoute = ({ children }) => {
  const { userToken } = useUserToken();

  if (!userToken) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
